module.exports = __webpack_public_path__ + "static/img/default-pic.b7318e84.png";